import { createAction, props } from '@ngrx/store';
import { RouterStateUrl } from '../router/custom-serializer';

export const AddNavigationsPrevRout = createAction(
  '[Navigation] AddNavigationsPrevRout',
  props<{ rout: RouterStateUrl, state: any }>()
);
